import { SET_USER, SESSION_LOADING, SESSION_FAILED } from '../actions/user.actions';
const initalState = {
  user: null,
  notifications: null,
  properties: {},
  loaded: false,
  sessionStatus: 'idle',
  error: null
};
export default (state = initalState, action) => {
  let nextUser;
  switch (action.type) {
    case SESSION_LOADING:
      return {
        ...state,
        loaded: false,
        sessionStatus: 'loading'
      };
    case SESSION_FAILED:
      return {
        ...state,
        loaded: false,
        sessionStatus: 'error'
      };
    case SET_USER:
      nextUser = {
        ...state.user
      };
      if (action.payload.user) {
        nextUser = {
          ...nextUser,
          ...action.payload.user
        };
      } else {
        nextUser = null;
      }
      return {
        ...state,
        loaded: true,
        sessionStatus: 'ready',
        error: action.payload.error,
        notifications: action.payload.notifications,
        user: nextUser,
        properties: action.payload.properties || state.properties
      };
    default:
      return state;
  }
};